/**
 * @author Ariel
 * @date 2022-11-23
 */
import React from 'react'
import moment from "moment";
import { component_tool } from '../../../../tool'
import {WizTableForm} from "../../../common";

let { WizPopover } = component_tool;
let componentName = 'learningRecord'

const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const areaConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1,organizationNodeCategory: ["2"] } })
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1,organizationNodeCategory: ["3"]} })

const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

const columns = () => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '学员帐号',
      name: 'userName',
      searchItem: {},
    },
    {
      title: '学员姓名',
      name: 'fullName',
      searchItem: {},
    },
    {
      title: '区域',
      name: 'areaId',
      searchItem: {
        ...areaConfig,
        selectType: 'radio',
        diy: WizTableForm,
        destroyOnClose: true
      },
    },
    {
      title: '经销商',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        selectType: 'radio',
        diy: WizTableForm
      },
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        selectType: 'radio',
        diy: WizTableForm

      },
    },
    {
      title: "通过状态",
      name: "pass",
      dict: [
        {code: 0, codeName: "未通过"},
        {code: 1, codeName: "已通过"}
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '学员帐号',
      name: 'userName',
      tableItem: {},
    },
    {
      title: '学员姓名',
      name: 'fullName',
      tableItem: {},
    },
    {
      title: '任职信息',
      name: 'identityLists',
      tableItem: {
        render: (val = [], record) => {
          if (!val.length) { return '暂无任职' }
          let { areaName, orgName, positionName } = val[0]
          let _titleView = [`${areaName}>${orgName}-${positionName}`]
          if (val.length > 1) {
            _titleView.push(<span className='manager-person-text-color'> ...</span>)
          }
          return (
            <WizPopover
              content={val.map((e) => <p>{`${e['areaName']}>${e['orgName']}-${e['positionName']}`}</p>)}
              placement="rightTop"
            >
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: '学习进度',
      name: 'finishRate',
      tableItem: {
        render: (text, record) => {
          return text + '%'
        }
      }
    },
    {
      title: "通过状态",
      name: "pass",
      dict: [
        {code: 0, codeName: "未通过"},
        {code: 1, codeName: "已通过"}
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "完成时间",
      name: "completedDate",
      tableItem: {
        width: 200,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
    {
      title: "最后学习时间",
      name: "lastTime",
      tableItem: {
        width: 200,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
  ]
}

const templateConfig = (e) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(),
        btnAccessCheck: false,
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
      }
    }
  }
}

const apis = (record) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {programId: record.id}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {programId: record.id}
      }
    },
  }
}


let reduxTemplateConfig = (args) => {
  let {record} = args
  return {
    apis: apis(record),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
